/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DeviceTypeEnum from './DeviceTypeEnum';

/**
 * The UserDeviceToken model module.
 * @module model/UserDeviceToken
 * @version 1.0.0
 */
class UserDeviceToken {
    /**
     * Constructs a new <code>UserDeviceToken</code>.
     * @alias module:model/UserDeviceToken
     * @param deviceToken {String} 
     */
    constructor(deviceToken) { 
        
        UserDeviceToken.initialize(this, deviceToken);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, deviceToken) { 
        obj['device_token'] = deviceToken;
    }

    /**
     * Constructs a <code>UserDeviceToken</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserDeviceToken} obj Optional instance to populate.
     * @return {module:model/UserDeviceToken} The populated <code>UserDeviceToken</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserDeviceToken();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('device_token')) {
                obj['device_token'] = ApiClient.convertToType(data['device_token'], 'String');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('device_type')) {
                obj['device_type'] = DeviceTypeEnum.constructFromObject(data['device_type']);
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserDeviceToken</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserDeviceToken</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UserDeviceToken.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['device_token'] && !(typeof data['device_token'] === 'string' || data['device_token'] instanceof String)) {
            throw new Error("Expected the field `device_token` to be a primitive type in the JSON string but got " + data['device_token']);
        }

        return true;
    }


}

UserDeviceToken.RequiredProperties = ["device_token"];

/**
 * @member {Number} id
 */
UserDeviceToken.prototype['id'] = undefined;

/**
 * @member {String} device_token
 */
UserDeviceToken.prototype['device_token'] = undefined;

/**
 * @member {Number} user_id
 */
UserDeviceToken.prototype['user_id'] = undefined;

/**
 * @member {module:model/DeviceTypeEnum} device_type
 */
UserDeviceToken.prototype['device_type'] = undefined;

/**
 * @member {Date} created_at
 */
UserDeviceToken.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
UserDeviceToken.prototype['updated_at'] = undefined;






export default UserDeviceToken;

